module.exports = __webpack_public_path__ + "98dfa8e0e01811cbe1c208bda4cb38aa.fbx";